import React, { useState } from "react";
import {
  arrayBufferToBase64,
  deriveAESKey,
  deriveSharedSecret,
  encryptData,
  generateEphemeralKeyPair,
} from "../../../utils/crypto.utils";
import {
  getKeyFromServer,
  savePaymentAccount,
} from "../../../redux/user/actions";
import { Modal, Form } from "react-bootstrap";
import AppButton from "../Ui/AppButton";
import { APP_ERRORS } from "../../../config/appErrors";
import { APP_CONST, PaymentAccountType } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";

const encryptFormData = async (data) => {
  // Step 1: Generate ephemeral key pair
  const keyPair = await generateEphemeralKeyPair();

  // Step 2: Export client's public key as JWK
  const clientPublicKey = arrayBufferToBase64(
    await window.crypto.subtle.exportKey("raw", keyPair.publicKey),
  );

  // Step 3: Get encrypted key for card data from server
  const keyResponse = await getKeyFromServer(clientPublicKey);

  if (keyResponse) {
    const sharedSecret = await deriveSharedSecret(
      keyPair.privateKey,
      keyResponse?.data?.data.key,
    );

    // Step 6: Derive AES-256-GCM key from shared secret using HKDF
    const aesKey = await deriveAESKey(sharedSecret);

    const { ciphertext, iv } = await encryptData(JSON.stringify(data), aesKey);

    return { data: ciphertext, iv };
  }
};

const PaymentAccountBank = ({
  show,
  handleClose,
  fetchPaymentAccounts,
  paymentAccOtpConfig,
}) => {
  const [formData, setFormData] = useState(false);
  const [formErrors, setFormErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const validateFormData = (data = formData) => {
    const { accountName, accountNumber, bankName, ifscCode } = data;

    let errorsObject = {};
    if (!Boolean(accountName) || accountName == "") {
      errorsObject["accountName"] = APP_ERRORS.PLAYER_BANK_DETAILS.ACCOUNT_NAME;
    }

    if (!Boolean(accountNumber) || accountNumber == 0 || accountNumber == "") {
      errorsObject["accountNumber"] =
        APP_ERRORS.PLAYER_BANK_DETAILS.ACCOUNT_NUMBER;
    }

    if (!Boolean(ifscCode) || ifscCode == "") {
      errorsObject["ifscCode"] = APP_ERRORS.PLAYER_BANK_DETAILS.IFSC_CODE;
    }

    if (!Boolean(bankName) || bankName == "") {
      errorsObject["bankName"] = "Bank name is required";
    }

    setFormErrors(errorsObject);
    return errorsObject;
  };

  const handleChange = (e) => {
    const data = { ...formData, [e?.target?.name]: e?.target?.value };
    validateFormData(data);
    setFormData(data);
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    const validation = validateFormData();
    if (Object.keys(validation).length > 0) {
      return;
    }

    setIsLoading(true);

    let encryptedData = await encryptFormData({
      ...formData,
      type: PaymentAccountType.Bank,
    });

    if (paymentAccOtpConfig?.isotpRequired) {
      encryptedData["otp"] = paymentAccOtpConfig?.otpValue;
    }

    const response = await savePaymentAccount(encryptedData);
    setIsLoading(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Record added");
      fetchPaymentAccounts();
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="changePasswordModal EnterOtpModal"
      centered
    >
      <Modal.Header closeButton>Add Bank Account</Modal.Header>
      <Modal.Body>
        <Form className={"playerBankDetailsEdit"} onSubmit={handleSubmit}>
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"text"}
              color="black"
              placeholder={"Account Name"}
              name={"accountName"}
              onChange={handleChange}
              value={formData?.accountName}
              isInvalid={!!formErrors["accountName"]}
            />

            <Form.Control.Feedback type="invalid">
              {formErrors["accountName"]}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"number"}
              name={"accountNumber"}
              placeholder="Account Number"
              onChange={handleChange}
              value={formData?.accountNumber}
              isInvalid={!!formErrors["accountNumber"]}
            />

            <Form.Control.Feedback type="invalid">
              {formErrors["accountNumber"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"text"}
              placeholder={"Bank name"}
              name={"bankName"}
              value={formData?.bankName}
              onChange={handleChange}
              isInvalid={!!formErrors["bankName"]}
            />

            <Form.Control.Feedback type="invalid">
              {formErrors["bankName"]}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"text"}
              placeholder={"IFSC code"}
              name={"ifscCode"}
              value={formData?.ifscCode}
              onChange={handleChange}
              isInvalid={!!formErrors["ifscCode"]}
            />

            <Form.Control.Feedback type="invalid">
              {formErrors["ifscCode"]}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-center">
            <AppButton
              isLoading={isLoading}
              text="Save details"
              type="submit"
            />
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default PaymentAccountBank;
